import React from 'react';
import { Tooltip } from 'antd';
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    PauseCircleOutlined,
    PlayCircleOutlined,
    PoweroffOutlined,
    QuestionCircleOutlined,
    RightCircleOutlined,
    SyncOutlined,
    WarningOutlined,
    WifiOutlined,
} from '@ant-design/icons';
import { Catcher, ShowRawDataInfo } from '../../';
import cx from 'classnames';
import { ISubscriberStatusView, SubscriberType } from '../../../interfaces';
import { getSubscriberStatusText } from '../../../middleware';
import Styles from '../../styles/m_itemCardStyles.less';

const showStatus = (subStatus?: SubscriberType): ISubscriberStatusView => {
    switch (subStatus) {
        case SubscriberType.LIVE:
            return { status: getSubscriberStatusText(subStatus), className: Styles.green, Icon: WifiOutlined };
        case SubscriberType.ACTIVE:
            return { status: getSubscriberStatusText(subStatus), className: Styles.blue, Icon: PlayCircleOutlined };
        case SubscriberType.ACTIVE_THIS_MONTH:
            return {
                status: getSubscriberStatusText(SubscriberType.ACTIVE),
                tooltip: getSubscriberStatusText(subStatus),
                className: Styles.blue,
                Icon: RightCircleOutlined,
            };
        case SubscriberType.READY:
            return { status: getSubscriberStatusText(subStatus), className: Styles.yellow, Icon: CheckCircleOutlined };
        case SubscriberType.PRE_ACTIVE:
            return { status: getSubscriberStatusText(subStatus), className: Styles.orange, Icon: PauseCircleOutlined };
        case SubscriberType.UNKNOWN:
            return { status: getSubscriberStatusText(subStatus), className: Styles.red, Icon: QuestionCircleOutlined };
        case SubscriberType.SUSPENDED:
            return { status: getSubscriberStatusText(subStatus), className: Styles.red, Icon: PoweroffOutlined };
        case SubscriberType.TERMINATED:
            return { status: getSubscriberStatusText(subStatus), className: Styles.red, Icon: CloseCircleOutlined };
        case SubscriberType.UNMANAGED:
            return { status: getSubscriberStatusText(subStatus), className: Styles.red, Icon: WarningOutlined };
        default:
            return {
                status: getSubscriberStatusText(SubscriberType.UNKNOWN),
                className: Styles.red,
                Icon: QuestionCircleOutlined,
            };
    }
};

type IShowSubscriberStatus = {
    dispatchLock?: boolean;
    isSmallIcon?: boolean;
    subStatus?: SubscriberType;
    transactionError?: any;
    children?: never;
};

export const ShowSubscriberStatus: React.FC<IShowSubscriberStatus> = ({
    dispatchLock,
    isSmallIcon,
    subStatus,
    transactionError,
}: IShowSubscriberStatus) => {
    const { className, Icon, status, tooltip } = showStatus(subStatus);

    return (
        <Catcher>
            <div className={Styles.subscriberStatus}>
                <div className={cx(Styles.icon, { [Styles.smallIcon]: isSmallIcon })}>
                    {dispatchLock ? (
                        <SyncOutlined spin />
                    ) : (
                        <>
                            <div className={cx(Styles.trafficLite, className)} />
                            {Icon ? (
                                <Tooltip placement="topLeft" title={tooltip || status}>
                                    <Icon className={className} />
                                </Tooltip>
                            ) : null}
                        </>
                    )}
                </div>
                <div className={Styles.info}>
                    <div className={Styles.status}>{status}</div>
                    <ShowRawDataInfo transactionInfo={transactionError} isError />
                </div>
            </div>
        </Catcher>
    );
};
